"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cast_1 = require("../../utilites/cast");
class FileInfo {
    constructor() {
        this.name = '';
        this.type = '';
        this.size = 0;
        this.lastModified = 0;
        this.path = '';
        this.url = '';
    }
    static from(object) {
        if (object instanceof File) {
            return FileInfo.fromFile(object);
        }
        else if (object.file && object.file instanceof File) {
            return cast_1.castToType(Object.assign(Object.assign({}, object), FileInfo.fromFile(object.file)), FileInfo);
        }
        else {
            return cast_1.castToType(object, FileInfo);
        }
    }
    static fromFile(file) {
        const o = new FileInfo();
        o.name = file.name || '';
        o.type = file.type || '';
        o.size = file.size || 0;
        o.lastModified = file.lastModified || 0;
        o.file = file;
        return o;
    }
}
exports.FileInfo = FileInfo;
FileInfo.propFactory = {
    file: (file) => { if (file instanceof File)
        return file; }
};
